import { createFileRoute } from "@tanstack/react-router";

import { AboutContent } from "@/components/site/AboutContent";
import { PageHero } from "@/components/site/PageHero";
import { SiteFooter } from "@/components/site/SiteFooter";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About — adaptED" },
      {
        name: "description",
        content: "Who adaptED is, why we exist and the impact we are building for South African learners.",
      },
      { property: "og:title", content: "About — adaptED" },
      { property: "og:description", content: "The story and mission behind adaptED." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://www.adapted.info/about" },
      { property: "og:site_name", content: "adaptED" },
      { name: "twitter:title", content: "About — adaptED" },
      { name: "twitter:description", content: "The story and mission behind adaptED." },
    ],
    links: [{ rel: "canonical", href: "https://www.adapted.info/about" }],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <main id="top">
      <PageHero
        label=""
        title="About"
        paragraph="adaptED is a South African EdTech company building safe, learning-first, CAPS-native AI technology for high school learners."
      />
      <AboutContent />
      <SiteFooter />
    </main>
  );
}
